import {
  clearStartingTeacherVerifications,
  readStartingTeacherProgress,
  verifyStartingTeacherSkill,
} from "../../passport/data/starting-teacher-progress.js";
import { skillCompletion, startingTeacherRoute } from "../../passport/data/starting-teacher-route.js";

export type MentorCompetency = {
  id: string;
  competencyId: string;
  completedOn: string;
  verified: boolean;
};

export type MentorMentee = {
  id: string;
  name: string;
  context: string;
};

/** Starting teachers assigned to the demo mentor. Their learning state is read from their own route. */
export const mentorMentees: readonly MentorMentee[] = [
  {
    id: "noor",
    name: "Noor de Vries",
    context: "Groep 4",
  },
  {
    id: "kevin",
    name: "Kevin Jansen",
    context: "Nog geen groep",
  },
];

export function completedMentorCompetencies(employeeId: string): MentorCompetency[] {
  const progress = readStartingTeacherProgress(employeeId);
  return startingTeacherRoute.flatMap((competency) =>
    competency.skills
      .filter((skill) => skillCompletion(skill, progress).complete)
      .map((skill) => ({
        id: skill.id,
        competencyId: competency.id,
        completedOn: progress.skillCompletedAt[skill.id] ?? "",
        verified: Boolean(progress.skillVerifiedAt[skill.id]),
      })),
  );
}

export function mentorMeeting(employeeId: string): string | null {
  return readStartingTeacherProgress(employeeId).mentorMeetingDate;
}

function parseLocal(iso: string): Date {
  const [date = "", time] = iso.split("T");
  const [year = 0, month = 1, day = 1] = date.split("-").map(Number);
  if (!time) return new Date(year, month - 1, day);
  const [hour = 0, minute = 0] = time.split(":").map(Number);
  return new Date(year, month - 1, day, hour, minute);
}

export function formatMentorWhen(iso: string, language: string, withTime = false): string {
  const locale = language.toLowerCase().startsWith("en") ? "en-GB" : "nl-NL";
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(parseLocal(iso));
}

export function verifyCompetency(employeeId: string, skillId: string): void {
  verifyStartingTeacherSkill(employeeId, skillId);
}

export function clearVerifications(): void {
  clearStartingTeacherVerifications(mentorMentees.map((mentee) => mentee.id));
}
